import React from 'react';
import { HelpCircle, ChevronRight } from 'lucide-react';

const RightPanel = ({ isOpen, togglePanel, selectedService }) => {
  if (!isOpen) {
    return (
      <div className="border-start w-auto d-flex justify-content-center p-2">
        <button
          onClick={togglePanel}
          className="p-1 rounded btn btn-light"
        >
          <HelpCircle size={20} />
        </button>
      </div>
    );
  }

  return (
    <div className="bg-light w-25 border-start overflow-auto">
      <div className="p-3 border-bottom d-flex align-items-center justify-content-between">
        <h2 className="fw-medium d-flex align-items-center mb-0">
          <HelpCircle size={16} className="me-2" />
          Help & Resources
        </h2>
        <button
          onClick={togglePanel}
          className="p-1 rounded btn btn-light"
        >
          <ChevronRight size={18} />
        </button>
      </div>
      <HelpContent service={selectedService} />
    </div>
  );
};

const HelpContent = ({ service }) => {
    return (
        <div className="p-4">
            <h3 className="fw-medium mb-2">{service} Documentation</h3> {/* Bootstrap: fw-medium, mb-2 */}
            <ul className="list-unstyled text-primary small"> {/* Bootstrap: list-unstyled, text-primary, small */}
                <li className="text-decoration-underline cursor-pointer">Getting started</li> {/* Bootstrap: text-decoration-underline */}
                <li className="text-decoration-underline cursor-pointer">API reference</li>
                <li className="text-decoration-underline cursor-pointer">Best practices</li>
                <li className="text-decoration-underline cursor-pointer">Tutorials</li>
            </ul>
            <h3 className="fw-medium mb-2 mt-4">Common Actions</h3> {/* Bootstrap: fw-medium, mb-2, mt-4 */}
            <ul className="list-unstyled small"> {/* Bootstrap: list-unstyled, small */}
                <li className="list-group-item list-group-item-action cursor-pointer">Create new {service.toLowerCase()}</li> {/* Bootstrap: list-group-item list-group-item-action */}
                <li className="list-group-item list-group-item-action cursor-pointer">Import configuration</li>
                <li className="list-group-item list-group-item-action cursor-pointer">Export data</li>
            </ul>
        </div>
    );
};

export default RightPanel;